import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-bootstrap';
import TextareaAutosize from 'react-autosize-textarea';
import PopupDoneBox from 'Popups/SelfServeBuilderPopups/PopupDoneBox';
import WithHover from 'WithHover';
import styles from '../../sass/main.scss';

const DEFAULT_INPUT_PADDING = 20;
const DEFAULT_TOP_PADDING = 30;
const POPUP_DONE_BOX_HEIGHT = 40;
const POPUP_DONE_BOX_WIDTH = 120;


class BoxPopupNameInput extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onBlur = this.onBlur.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onDone = this.onDone.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.onResize = this.onResize.bind(this);

    this.state = {
      isFocused: true,
      isDone: false,
      doneOffset: 0,
      value: this.props.value,
    };
  }

  componentDidMount() {
    this.boxPopupNameInput.focus();
    if (this.props.doneOnRender) {
      this.onDone();
    }
    if (this.props.isSampleState && !this.props.isFirstSamplePopupMounted) {
      this.onDone();
      this.props.setFirstSamplePopupMounted();
    }
  }

  onFocus() {
    this.setState({
      isFocused: true,
    });
  }

  onBlur() {
    this.setState({
      isFocused: false,
    });
  }

  onChange(e) {
    this.setState({
      value: e.target.value,
    });

    this.props.disablePopupCreation();

    if (e.target.value.length !== 0) {
      this.props.hideError();
    }
  }

  onDone(e) {
    this.props.onBoxNameChange(this.state.value);
    this.setState({
      isDone: true,
    });
    this.props.onBoxPopupNameInputResizeHeight(0);
    this.props.onDone(e);
  }

  onEdit(e) {
    if (!this.props.isEditable) {
      return;
    }
    this.setState({
      isDone: false,
    });
    this.props.onEdit(e);
  }

  onResize(e) {
    this.onChange(e);

    const height = Math.min(
      parseInt(e.target.style.height, 10),
      parseInt(e.target.style.maxHeight, 10),
    ) || 0;

    this.props.onBoxPopupNameInputResizeHeight(height - DEFAULT_INPUT_PADDING);
    this.setState({
      doneOffset: height - DEFAULT_TOP_PADDING,
    });
  }

  render() {
    const doneDisabled = this.state.value.length === 0;
    return (
      <div
        className="box-popup-name-input"
        onMouseOver={this.props.onMouseOver}
        onMouseOut={this.props.onMouseOut}
        style={{
          background: this.state.isDone ?
            styles.boxPopupNameCompleteContainerColor :
            styles.boxPopupNameIncompleteContainerColor,
          boxShadow: this.props.error ? `0 0 5px 0 ${styles.boxPopupNameErrorColor}` : `0 0 5px 0 ${styles.boxPopupNameShadowColor}`,
          border: `1px solid ${this.props.error ? styles.boxPopupNameErrorColor : styles.boxPopupNameCompleteContainerColor}`,
        }}
      >

        {this.props.error &&
          <Tooltip
            id={`${this.props.id}-tooltip`}
            placement="top"
            className="in box-popup-name-input-tooltip"
          >
            <div className="tooltip-content">
              Type a question and click done. Or delete the textbox.
            </div>
          </Tooltip>
        }

        {!this.state.isDone &&
          <React.Fragment>
            <TextareaAutosize
              className="box-popup-name-input-textarea"
              onResize={this.onResize}
              rows={1}
              maxRows={9}
              style={{
                color: styles.boxPopupNameInputTextColor,
                fontStyle: this.state.value.length ? 'normal' : 'italic',
              }}
              placeholder="Type Question Here"
              onFocus={this.onFocus}
              onChange={this.onChange}
              onBlur={this.onBlur}
              value={this.state.value}
              ref={(ref) => { this.boxPopupNameInput = ref; }}
            />
            <button
              className="box-popup-name-input-done-btn"
              disabled={doneDisabled}
              style={{ top: this.state.doneOffset }}
              onClick={this.onDone}
            >
              Done
            </button>
          </React.Fragment>
        }

        {this.state.isDone &&
          <PopupDoneBox
            isEditable={this.props.isEditable}
            onClick={this.onEdit}
            style={{
              color: styles.boxPopupNameDoneTextColor,
              width: this.props.isEditable ? this.props.width : `${POPUP_DONE_BOX_WIDTH}px`,
              height: `${POPUP_DONE_BOX_HEIGHT}px`,
            }}
            label={this.props.value}
            superScript={this.props.getSuperScriptValue(this.props.id, this.props.label)}
          />
        }
      </div>
    );
  }
}

BoxPopupNameInput.defaultProps = {
  doneOnRender: false,
  isEditable: true,
  isFirstSamplePopupMounted: false,
  isSampleState: false,
  error: false,
  setFirstSamplePopupMounted: () => null,
};

BoxPopupNameInput.propTypes = {
  disablePopupCreation: PropTypes.func.isRequired,
  doneOnRender: PropTypes.bool,
  isEditable: PropTypes.bool,
  isFirstSamplePopupMounted: PropTypes.bool,
  isSampleState: PropTypes.bool,
  error: PropTypes.bool,
  getSuperScriptValue: PropTypes.func.isRequired,
  hideError: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  onBoxNameChange: PropTypes.func.isRequired,
  onBoxPopupNameInputResizeHeight: PropTypes.func.isRequired,
  onDone: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  setFirstSamplePopupMounted: PropTypes.func,
  value: PropTypes.string.isRequired,
  width: PropTypes.number.isRequired,
};

export default WithHover(BoxPopupNameInput);



// WEBPACK FOOTER //
// ./src-react/withSelfServeCreator/BoxPopupNameInput.jsx